namespace $.$$ {

	$mol_style_define( $shm_dashboard_admin_settings, {
		width: '100%',
		minWidth: 0,
		flexDirection: 'column',

		Defaults: {
			flexWrap: 'wrap',
			gap: $mol_gap.space,
			alignItems: 'flex-end',
			padding: $mol_gap.block,
			border: {
				bottom: {
					width: '1px',
					style: 'solid',
					color: $mol_theme.line,
				},
			},
		},

		Defaults_title: {
			flex: { basis: '100%' },
			font: { weight: 'bold' },
		},

		Notifications: {
			flexWrap: 'wrap',
			gap: $mol_gap.space,
			alignItems: 'flex-end',
			padding: $mol_gap.block,
		},

		Notifications_title: {
			flex: { basis: '100%' },
			font: { weight: 'bold' },
		},

		Telegram_notifications: {
			flex: {
				direction: 'column',
				grow: 1,
				shrink: 1,
				basis: '18rem',
			},
			gap: $mol_gap.text,
		},

		Max_notifications: {
			flex: {
				direction: 'column',
				grow: 1,
				shrink: 1,
				basis: '18rem',
			},
			gap: $mol_gap.text,
		},
	} )

}
